import { useEffect, useRef, useState } from "react";
import { printer } from "../../asset";
import { CustomButton, PageHeader } from "../../components";
import IDCardContainer from "./IDCardContainer";
import { usePrint } from "../../util/hooks/usePrint";
import { useNavigate, useParams } from "react-router-dom";
import StaffApis from "../../api/staffApis";
import { Staff } from "../../types/staff";

export default function StaffIdCard() {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const { staffId } = useParams<{ staffId: string }>();

  const [staffData, setStaffData] = useState<Staff | undefined>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStaff = async () => {
      if (!staffId) return;

      const res = await StaffApis.getStaffById(Number(staffId));
      if (res?.data) {
        setStaffData(res.data);
      }
    };

    fetchStaff();
  }, [staffId]);

  // PRINT
  const handlePrint = usePrint(cardRef, {
    documentTitle: "ID_Card",
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center">
        <PageHeader showBack />
        <div className="flex justify-end items-end gap-3">
          <CustomButton
            text="Edit Details"
            color="bg-primary-500"
            onClick={() => navigate(`/staff/staff-profile/${staffData?.staffId}`)}
          />
          <CustomButton
            text="Print/Download"
            color="bg-success-600"
            icon={printer}
            onClick={handlePrint}
          />
        </div>
      </div>
      <div className="bg-white rounded-lg py-7 pb-14 w-full gap-9 flex flex-col justify-center items-center">
        <div className="flex flex-col gap-3 justify-center items-center">
          <h3 className="text-neutral-300 text-sm font-semibold">
            Create Staff ID Card{" "}
          </h3>
          <p className="text-3xl font-semibold text-primary-600">
            Easily build and download ID Cards
          </p>
        </div>
        <div ref={cardRef} className="print-wrapper">
          {staffData && <IDCardContainer staff={staffData} />}
        </div>
      </div>
    </div>
  );
}
